import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import styles from './styles.scss';
import { arrayOf, func, shape, string, bool, oneOf } from 'prop-types';
import _ from 'lodash';
import { advertiserPropTypes, functionAdvertiserPropTypes } from '../types';
import { getNextTime, getNextTimeStart, isCompareDate, isValidTime } from '../../../helpers/formatData';
import AdvertiserCommonInfo from '../../../components/AdvertiserCommonInfo';
import BasePromptDialog from '../../../components/BasePromptDialog';
import { CONNECT_GA_STATUS, TRACKING_SOURCE_NAME } from '../../../helpers/constant';
import { WEB_DATA_TYPE } from '../../../state/modules/app/playout/constant.js';
import { validateIndustryCategorization } from '../../../helpers/validate';
import { getDefaultEmailInfoByType } from '../../../components/InvitationForm/helpers';

const DATE_RANGES = "date_ranges";
const getListRules = props => {
  const { appSetting, edit, advertiser } = props;
  let listRules = [];
  if (!edit) {
    let data = _.get(appSetting, "data", []);
    let dateRanges =
      data !== {}
        ? data.filter(item => {
            return item["setting_name"] === DATE_RANGES;
        })
        : {};
    let settingValueDateRanges = _.get(dateRanges[0], "setting_value", {});
    listRules = _.get(settingValueDateRanges, "ranges", []);

  } else {
    listRules = _.get(advertiser, "custom_date_range.ranges", []);
  }
  return listRules;
};

const getDefaultValue = props => {
  const { appSetting, edit, advertiser } = props;
  let defaultValue = 8;
  if (!edit) {
    let data = _.get(appSetting, "data", []);
    let dateRanges =
      data !== {}
        ? data.filter(item => {
            return item["setting_name"] === DATE_RANGES;
        })
        : {};
    let settingValueDateRanges = _.get(dateRanges[0], "setting_value", {});
    defaultValue = _.get(settingValueDateRanges, "default", 8);
  } else {
    defaultValue = _.get(advertiser, "custom_date_range.default", 8);
  }
  return defaultValue;
};

const getIsDisableRules = props => {
  const { appSetting, edit, advertiser } = props;
  let isDisabledRules = false;
  if (!edit) {
    let data = _.get(appSetting, "data", []);
    let dateRanges =
      data !== {}
        ? data.filter(item => {
            return item["setting_name"] === DATE_RANGES;
        })
        : {};
    let settingValueDateRanges = _.get(dateRanges[0], "setting_value", {});
    isDisabledRules = !_.get(settingValueDateRanges, "isOverride", false);
  } else {
    isDisabledRules = !_.get(advertiser, "custom_date_range.isOverride", false);
  }
  return isDisabledRules;
};

export default class AdvertiserDetails extends Component {
  static propTypes = {
    title: string,
    logoTitle: string,
    logoDescription: string,
    recommendedImageText: string,
    defaultSaveBtnLabel: string,
    secondarySaveBtnLabel: string,
    cancelButtonLabel: string,
    textFieldLabel: string,
    multiMarketTitle: string,
    updateAdvertiser: func,
    advertiser: advertiserPropTypes,
    ...functionAdvertiserPropTypes,
    multiMarketOptions: arrayOf(shape({
      name: string,
      value: oneOf(['0','1'])
    })),
    onAddAdvertiser: func,
    onUpdateAdvertiser: func,
    displayMultiMarkets: bool,
    editMultiMarketMsg: string,
    multiMarketTooltipText: string,
    isSendInvite: bool,
  };

  static defaultProps = {
    title: 'Advertiser Details',
    defaultSaveBtnLabel: 'Save & Send Invite',
    secondarySaveBtnLabel: 'Save',
    cancelButtonLabel: 'Cancel',
    multiMarketOptions: [
      {
        name: 'Yes',
        value: '1'
      },
      {
        name: 'No',
        value: '0'
      }
    ]
  };

  state = {
    isEditing: false,
    listRules: getListRules(this.props),
    defaultValue: getDefaultValue(this.props),
    isDisabledRules: getIsDisableRules(this.props),
    appSetting: this.props.appSetting,
    isShowUploadForm: false,
    urlImage: "",
    resendInvitation: true,
    isOverridePromptOpen: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { appSetting, edit, advertiser } = nextProps;
    let listRules = [];
    const DEFAULT_CONFIG_VALUE = 8; //default custom window range: 8 mins
    let isDisabledRules = false;
    if (
      !edit
      && appSetting &&
      JSON.stringify(appSetting) !== JSON.stringify(prevState.appSetting)
    ) {
      let data = _.get(appSetting, "data", []);
      let dateRanges =
        data !== {}
          ? data.filter(item => {
              return item["setting_name"] === DATE_RANGES;
          })
          : {};
      let settingValueDateRanges = _.get(dateRanges[0], "setting_value", {});
      let defaultValue = _.get(
        settingValueDateRanges,
        "default",
        DEFAULT_CONFIG_VALUE
      );
      listRules = _.get(settingValueDateRanges, "ranges", []);
      if (listRules) {
        const firstRule = listRules[0];
        const checkCompareRule = _.get(firstRule, "checkCompare");
        if (_.isUndefined(checkCompareRule)) {
          listRules.forEach((rule, idx) => {
            listRules[idx].check = true;
            listRules[idx].checkCompare = true;
          });
        }
      }
      isDisabledRules = !_.get(settingValueDateRanges, "isOverride", false);
      return {
        listRules,
        defaultValue,
        isDisabledRules,
        appSetting
      };
    }
    if (edit) {
      listRules = _.get(advertiser, "custom_date_range.ranges", []);
      if (listRules) {
        const firstRule = listRules[0];
        const checkCompareRule = _.get(firstRule, "checkCompare");
        if (_.isUndefined(checkCompareRule)) {
          listRules.forEach((rule, idx) => {
            listRules[idx].check = true;
            listRules[idx].checkCompare = true;
          });
        }
      }
      isDisabledRules = !_.get(
        advertiser,
        "custom_date_range.isOverride",
        false
      );
      let defaultValue = _.get(
        advertiser,
        "custom_date_range.default",
        DEFAULT_CONFIG_VALUE
      );
      const resendInvitation = _.get(advertiser, 'trackingDataSourceName') !== TRACKING_SOURCE_NAME.WEB_UPLOAD;
      return {
        listRules,
        isDisabledRules,
        defaultValue,
        resendInvitation,
      };
    }
    return prevState;
  }

  componentDidMount() {
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
        folder_id: "",
        errMsg: ""
    });

  }

  onChangeStartTime = (value, index) => {
    this.setState(state => {
      const newListRules = [...state.listRules];
      newListRules[index].start = value;
      newListRules[index].check = isValidTime(index, newListRules);
      newListRules.forEach((rule, idx) => {
        rule.checkCompare = isCompareDate(rule);
        if (isValidTime(idx, newListRules)) {
          newListRules[idx].check = true;
        }
      });
      this.callUpdateAdvertiser(newListRules);
      return {
        listRules: newListRules,
        isEditing: true
      };
    });
  };

  onChangeEndTime = (value, index) => {
    this.setState(state => {
      const newListRules = [...state.listRules];
      newListRules[index].end = value;
      newListRules[index].check = isValidTime(index, newListRules);
      newListRules.forEach((rule, idx) => {
        rule.checkCompare = isCompareDate(rule);
        if (isValidTime(idx, newListRules)) {
          newListRules[idx].check = true;
        }
      });
      this.callUpdateAdvertiser(newListRules);
      return {
        listRules: newListRules,
        isEditing: true
      };
    });
  };

  onChangeValue = (value, index) => {
    this.setState(state => {
      const newListRules = [...state.listRules];
      newListRules[index].value = value;
      this.callUpdateAdvertiser(newListRules);
      return {
        listRules: newListRules,
        isEditing: true
      };
    });
  };

  onChangeDefaultValue = defaultValue => {
    const { advertiser, updateAdvertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      custom_date_range: {
        ...advertiser.custom_date_range,
        default: defaultValue
      }
    });
    this.setState({
      defaultValue,
      isEditing: true
    });
  };

  callUpdateAdvertiser = listRules => {
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      custom_date_range: {
        ...advertiser.custom_date_range,
        ranges: listRules
      }
    });
  };

  onAddItem = () => {
    this.setState(state => {
      const newListRules = [...state.listRules];
      const startTime = _.get(
        newListRules,
        [newListRules.length - 1, "end"],
        "01:00"
      );
      let startTimeNext = "01:00";
      if (startTime !== "01:00") {
        startTimeNext = getNextTimeStart(startTime);
      }
      const endTime = getNextTime(startTime);
      newListRules.push({
        start: startTimeNext,
        end: endTime,
        check: true,
        checkCompare: true,
        value: state.defaultValue
      });
      this.callUpdateAdvertiser(newListRules);
      return {
        listRules: newListRules,
        isEditing: true
      };
    });
  };

  onRemoveItem = index => {
    this.setState(state => {
      const newlistRules = [...state.listRules];
      newlistRules.splice(index, 1);
      newlistRules.forEach((rule, idx) => {
        rule.checkCompare = isCompareDate(rule);
        if (isValidTime(idx, newlistRules)) {
          newlistRules[idx].check = true;
        }
      });
      this.callUpdateAdvertiser(newlistRules);
      return {
        listRules: newlistRules,
        isEditing: true
      };
    });
  };

  handleNext = event => {
    event.preventDefault();
    const { next, edit, onSave } = this.props;
    this.setState({
      isEditing: false
    });
    if (edit) {
      return onSave();
    }
    next();
  };

  handleSave = () => {
    const { edit, onAddAdvertiser, onUpdateAdvertiser, isSendInvite } = this.props;
    if (!edit) {
      onAddAdvertiser && onAddAdvertiser();
    } else {
      onUpdateAdvertiser && onUpdateAdvertiser(isSendInvite);
    }
  }

  onChangeInput = event => {
    const name = event.target.value;
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      advertiser_name: name,
      errMsg: '',
      liveRead: {
        ...advertiser.liveRead,
        isEditing: true
      }
    });
    this.setState({
      isEditing: true
    });
  };

  handleMultiMarketChange = (selectedValue) => {
    const { updateAdvertiser, advertiser, multiMarketOptions } = this.props;
    const [ yes ] = multiMarketOptions;
    const isMultiMarket = selectedValue === yes.value;
    updateAdvertiser({
      ...advertiser,
      isMultiMarket,
      liveRead: {
        ...advertiser.liveRead,
        isEditing: true
      },
      multiMarketErrMsg: ''
    });
    this.setState({
      isEditing: true
    });
  };

  onEmailInfoChange = (emailInfo) => {
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      emailInfo,
      liveRead: {
        ...advertiser.liveRead,
        isEditing: true
      }
    });
    this.setState({
      isEditing: true
    });
  };

  uploadIMGSuccess = res => {
    const { reloadFilePicker } = this.props;
    this.setState({
      isShowUploadForm: false,
      urlImage: res[0].getUrl
    });
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      logo: {
        url: res[0].getUrl,
        unsignedUrl: res[0].unsignedUrl
      }
    });
    this.setState({
      isEditing: true
    });
    reloadFilePicker && reloadFilePicker();
  };

  handleResendInvitationChange = (resendInvitation) => {
    this.setState({ resendInvitation, isEditing: true });
  };
  
  handleIndustryCategorizationChange = (industry) => {
    const { updateAdvertiser, advertiser } = this.props;
    updateAdvertiser({
      ...advertiser,
      industry,
      industryCategorizationError: !_.isEmpty(advertiser.industryCategorizationError) ? 
        validateIndustryCategorization({
          ...advertiser,
          industry,
        }) : {},
    });
    this.setState({
      isEditing: true,
    });
  };
  
  handleConnectionTypeChange = (selectedValue) => {
    const {
      updateAdvertiser,
      advertiser,
      emailTemplate,
    } = this.props;
    const emailTemplateData = _.get(emailTemplate, "data", []);
    const emailInfo = getDefaultEmailInfoByType(selectedValue, emailTemplateData);
    updateAdvertiser({
      ...advertiser,
      trackingDataSourceName: selectedValue,
      trackingDataSourceNameError: '',
      emailInfo,
    });
    this.setState({
      isEditing: true,
      resendInvitation: selectedValue !== TRACKING_SOURCE_NAME.WEB_UPLOAD
    });
  }

  render() {
    const { isEditing } = this.state;
    const {
      edit,
      cancel,
      advertiser: {
        loaded,
        deleteId: advertiserId,
      },
      title,
      subtitle,
      advertiser,
      defaultSaveBtnLabel,
      secondarySaveBtnLabel,
      cancelButtonLabel,
      displayMultiMarkets,
      isSendInvite,
    } = this.props;

    const isDisabled = !loaded || (edit && !isEditing);
    const saveButtonLabel = isSendInvite ? defaultSaveBtnLabel : secondarySaveBtnLabel;

    return (
      <div className={styles.advertiserDetails}>
        <div className={styles.content}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>{title}</div>
          </div>
          <div className={styles.body}>
            <AdvertiserCommonInfo
              advertiser={{
                ...advertiser,
                advertiserId
              }}
              displayMultiMarkets={displayMultiMarkets}
              onSelectLogo={this.uploadIMGSuccess}
              onNameChange={this.onChangeInput}
              onMultiMarketChange={this.handleMultiMarketChange}
              onIndustryCategorizationChange={this.handleIndustryCategorizationChange}
              onConnectionTypeChange={this.handleConnectionTypeChange}
              onEmailInfoChange={this.onEmailInfoChange}
              edit={edit}
            />
            </div>
          <div className={styles.footer}>
            <Button
              data-test="addAdvFormSaveBtn"
              variant="contained"
              color="primary"
              type="submit"
              onClick={this.handleSave}
              disabled={isDisabled}
              data-veritone-element="advertiser-detail-button-next"
            >
              {saveButtonLabel}
            </Button>
            <Button
              variant="text"
              data-test="addAdvFormCancelBtn"
              onClick={cancel}
              data-veritone-element="advertiser-detail-button-cancel"
            >
              {cancelButtonLabel}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
